import { render, staticRenderFns } from "./KurehaArrow.vue?vue&type=template&id=4db721ec&scoped=true&"
import script from "./KurehaArrow.vue?vue&type=script&lang=js&"
export * from "./KurehaArrow.vue?vue&type=script&lang=js&"
import style0 from "./KurehaArrow.vue?vue&type=style&index=0&id=4db721ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db721ec",
  null
  
)

export default component.exports